import { getInstance } from "../../core/axios-gateway";
import { TSupplierRole } from "../../types/commercial";

const BASE_PATH = "/api/suppliers";

export type TEnsureSuperAdminResponse = {
  created: boolean;
  role: TSupplierRole;
};

// Crea (o devuelve, si ya existe) el rol "Super Admin" del supplier, con todos
// los permisos. Idempotente: `created` indica si se creó en esta llamada.
// Backend: POST /api/suppliers/admin/roles/super-admin?supplierId=... (admin-gated).
export const ensureSupplierSuperAdminRole = async (supplierId: string) => {
  return getInstance()
    .post<TEnsureSuperAdminResponse>(`${BASE_PATH}/admin/roles/super-admin`, null, {
      params: { supplierId },
    })
    .then((res) => res.data);
};
